// Constantes de marca (no son datos, es configuración)
export const BRAND = {
  name: "Turismo MDD",
  tagline: "Seguridad Total",
  city: "Tacna",
  legal: "TURISMO MADRE DE DIOS · RUC 20490436945",
};

export const ASSETS = {
  logo: "/logo-mdd-new.png",
  cityMap:
    "https://images.pexels.com/photos/11815816/pexels-photo-11815816.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const ROLE_META = {
  super_admin: { label: "Super Admin", color: "indigo",  desc: "Control total del sistema" },
  admin_ops:   { label: "Admin Ops",   color: "info",    desc: "Gestión diaria de operaciones" },
  dispatcher:  { label: "Despachador", color: "info",    desc: "Atiende conversaciones escaladas del bot" },
  accountant:  { label: "Contador",    color: "neutral", desc: "Acceso a reportes financieros" },
  driver:      { label: "Conductor",   color: "warning", desc: "Conductor de unidad propia de la empresa" },
  socio:       { label: "Socio",       color: "indigo",  desc: "Conductor con unidad propia asociada" },
  passenger:   { label: "Pasajero",    color: "success", desc: "Solicita carreras" },
  auditor:     { label: "Auditor",     color: "neutral", desc: "Acceso temporal de auditoría" },
};

export const roleLabel = (r) => ROLE_META[r]?.label || r;
export const roleColor = (r) => ROLE_META[r]?.color || "neutral";
